/**
 * Converts a string into a URL-friendly slug
 * - Trims whitespace
 * - Converts to lowercase
 * - Replaces non-alphanumeric characters (except hyphens and underscores) with hyphens
 * - Removes consecutive hyphens
 * - Removes leading/trailing hyphens and underscores
 */
export function slugify(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^[-_]+|[-_]+$/g, '');
}
